/* eslint-disable react/no-unknown-property */
// Shared material + lighting language so every 3D model reads as one brand system.

export const PALETTE = {
  violet: "#8b3dff",
  violetDeep: "#6c2bd9",
  pink: "#e7008a",
  coral: "#f97e0d",
  chrome: "#d8d8e2",
  charcoal: "#2a2a33",
  glass: "#b79bff",
};

// Material presets (spread onto <meshStandardMaterial {...mat.chrome} />)
export const MAT = {
  chrome: { color: PALETTE.chrome, metalness: 0.95, roughness: 0.22 },
  charcoal: { color: PALETTE.charcoal, metalness: 0.35, roughness: 0.6 },
  glass: {
    color: PALETTE.glass,
    metalness: 0.1,
    roughness: 0.15,
    transparent: true,
    opacity: 0.55,
    emissive: PALETTE.violet,
    emissiveIntensity: 0.35,
  },
  accent: {
    color: PALETTE.violet,
    emissive: PALETTE.violet,
    emissiveIntensity: 0.9,
    metalness: 0.4,
    roughness: 0.3,
  },
  pink: {
    color: PALETTE.pink,
    emissive: PALETTE.pink,
    emissiveIntensity: 0.7,
    metalness: 0.4,
    roughness: 0.3,
  },
  coral: {
    color: PALETTE.coral,
    emissive: PALETTE.coral,
    emissiveIntensity: 0.7,
    metalness: 0.4,
    roughness: 0.3,
  },
};

// Consistent three-point studio lighting used across every canvas.
export function Studio({ intensity = 1 }) {
  return (
    <>
      <hemisphereLight args={["#3a2a5a", "#0b0b0f", 0.5 * intensity]} />
      <ambientLight intensity={0.25 * intensity} />
      {/* key */}
      <directionalLight position={[4, 6, 5]} intensity={2.4 * intensity} color="#ffffff" />
      {/* cool violet rim */}
      <pointLight position={[-5, 2, -3]} intensity={2.6 * intensity} color={PALETTE.violet} />
      {/* warm accent fill */}
      <pointLight position={[3, -3, 4]} intensity={1.4 * intensity} color={PALETTE.coral} />
    </>
  );
}
